<template>
  <v-layout row wrap style="display: inline;">

    <v-flex xs12 >
      <p>Excellent! Check your ID data below. Then enter a unique password.</p>

        <v-flex class="mt-2"  >
          <v-text-field
            :append-icon="e1 ? 'visibility' : 'visibility_off'"
            @click:append="() => (e1 = !e1)"
            :type="e1 ? 'text' : 'text'"
            :class="e1 ? 'disk' : 'no-disk'"
            hint="At least 8 characters"
            v-validate="'required|min:8'"
            v-model="password"
            :error-messages="errors.collect('password')"
            label="Password"
            data-vv-name="password"
            class="notranslate"
          ></v-text-field>
        </v-flex>

    </v-flex>
    <v-flex xs12 >
      <v-checkbox
        required
        :error-messages="errors.collect('checkbox')"
        v-validate="'required'"
        data-vv-name="checkbox"
        value="1"
        v-model="checkbox">
        <template v-slot:label>
          <div>
            I attest to the ID data and accept the
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <router-link target="_blank" to="/terms-of-use">
                  License and terms of use
                </router-link>
              </template>
              Opens in new window
            </v-tooltip>
          </div>
        </template>
      </v-checkbox>
    </v-flex>
      <v-flex xs12 >
        <v-btn block class="mr-0"
               :loading="loading"
               @click="register()" color="success">CREATE ACCOUNT</v-btn>
        <v-btn block class="ml-0" @click="goToSignupStep(page, 'get-location-info')" color="primary">&#8592; Back</v-btn>
      </v-flex>

    <v-flex py-3 >
        <v-layout text-xs-left align-left justify-center column>
          <div class="mt-3 justify-center" style="width: 100%;height:100%;display: flex;">

            <div :style="{width: $store.getters.getIPad === true ? '50%' : '100%'}">
          <v-flex xs10 offset-xs1 sm8 offset-sm2>
            <div class="blue--text font-weight-bold" v-text="email" />
            <div class="font-weight-bold" v-text="phone" />
            <div v-text="addressLine1" />
            <div v-text="addressLine2" />
            <div v-text="city + ', ' + stateName" />
            <div v-text="'Postal Code: ' + postalCode + ', ' + countryName" />
          </v-flex>
            </div>
          </div>
        </v-layout>

      </v-flex>
      <!------------------- USER CERTIFICATE ------------------------------------->
    <UserCertificate
      :app-icon="appIcon"
      :app-name="appName"
      :app-name-class="appNameClass()"
      :default-name="defaultName"
      :f-name="fName"
      :l-name="lName"
      :image-data="imageData" />
    <!------------------- /USER CERTIFICATE ------------------------------------->

    <v-dialog
      v-model="creationLoaderDialog"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please wait. Your account is being created...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-layout>

</template>

<script>
  import crypto from '@/mixins/crypto'
  import Vue from 'vue'
  import VeeValidate from 'vee-validate'
  import {mapGetters, mapMutations} from 'vuex'
  import common from '@/mixins/common'
  import UserCertificate from './UserCertificate'

  Vue.use(VeeValidate)

  function getOS () {
    let userAgent = window.navigator.userAgent
    let platform = window.navigator.platform
    let macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
    let windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
    let iosPlatforms = ['iPhone', 'iPad', 'iPod']
    let os = 'Desktop'
    // Initially following code return Different OS but for now it will return only iOS, Android and Desktop
    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'DESKTOP'
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'IOS'
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'DESKTOP'
    } else if (/Android/.test(userAgent)) {
      os = 'ANDROID'
    } else if (!os && /Linux/.test(platform)) {
      os = 'DESKTOP'
    }
    return os
  }
  export default {
    name: 'ConfirmPwd',
    components: {UserCertificate},
    props: {
      page: {
        default: 'SignUp',
        type: String
      }
    },
    data () {
      return {
        appIcon: require('@/assets/logos/' + process.env.APP_ICON),
        appName: process.env.APP_NAME,
        defaultName: 'Your Name',
        loc: null,
        checkbox: null,
        isLocationOn: false,
        isFormValidated: false,
        loading: false,
        uname: '',
        e1: true,
        creationLoaderDialog: false,
        password: '',
        dictionary: {
          attributes: {
            email: 'E-mail Address'
          },
          custom: {
            checkbox: {
              required: 'Please select license and terms of use'
            }
          }
        }
      }
    },
    computed: {
      ...mapGetters('registration', ['getUserDetails']),
      addressLine1 () {
        return this.getUserDetails.address_line1
      },
      addressLine2 () {
        return this.getUserDetails.address_line2
      },
      postalCode () {
        return this.getUserDetails.postal_code
      },
      fName () {
        return this.getUserDetails.first_name
      },
      imageData () {
        return this.getUserDetails.profile_image
      },
      imageId () {
        return this.getUserDetails.image_id
      },
      lName () {
        return this.getUserDetails.last_name
      },
      email () {
        return this.decryptData(this.getUserDetails.email)
      },
      phone () {
        return '+' + this.decryptData(this.getUserDetails.phone)
      },
      selectedCountry () {
        return (this.getUserDetails.country)
      },
      selectedState () {
        return (this.getUserDetails.state)
      },
      city () {
        return (this.getUserDetails.city)
      },
      countryName () {
        return this.getUserDetails.country_name
      },
      stateName () {
        return this.getUserDetails.state_name
      }
    },
    mounted () {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      ...mapMutations('registration', [
        'setUser', 'resetUser'
      ]),
      appNameClass () {
        return this.appName.length > 25 ? 'body-2' : 'subheading'
      },
      register () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.creationLoaderDialog = true
            this.$store.commit('setLoadingDialog', true, { root: true })
            const data = {
              'email': this.email,
              'emailOtpId': this.getUserDetails.email_otp_id,
              'password': this.password,
              'firstName': this.fName,
              'lastName': this.lName,
              'imageId': this.imageId,
              'profile': {
                'city': this.city,
                'phoneNumber': this.phone,
                'phoneOtpId': this.getUserDetails.phone_otp_id,
                'addressLine1': this.addressLine1,
                'addressLine2': this.addressLine2,
                'stateId': this.selectedState,
                'countryId': this.selectedCountry,
                'postalCode': this.postalCode,
                'device': getOS()
              }
            }
            this.$http({
              url: process.env.API_URL + '/ws/userservice/course/rca/register',
              method: 'POST',
              data
            }).then((res) => {
              this.uname = res.data.friendlyName
              this.creationLoaderDialog = false
              this.$store.commit('setLoadingDialog', false, { root: true })

              this.setUser({
                ...this.getUserDetails,
                welcome: true
              })
              this.login()
            }, error => {
              this.creationLoaderDialog = false
              this.$store.commit('setLoadingDialog', false, { root: true })
              this.$store.commit('flashError', error.message, { root: true })
              this.creationLoaderDialog = false
            }).catch(error => {
              this.creationLoaderDialog = false
              this.$store.commit('setLoadingDialog', false, { root: true })
              this.$store.commit('flashError', error.message, { root: true })
            })
          } else {
            this.creationLoaderDialog = false
          }
        })
      },
      jsonToQueryString (json) {
        return '' +
          Object.keys(json).map(function (key) {
            return encodeURIComponent(key) + '=' +
              encodeURIComponent(json[key])
          }).join('&')
      },
      me () {
        this.$http({
          url: `${process.env.API_URL}/ws/playerservice/user/${this.email}?deck=${process.env.GAME_ID}`,
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + this.$auth.token()
          }
        }).then((res) => {
          this.$auth.user(res.data)
          this.$auth.watch.authenticated = true
          document.cookie = 'user_name=' + res.data.friendlyName + ';domain=cogneti.com'
          document.cookie = 'user_email=' + res.data.email + ';domain=cogneti.com'
          localStorage.setItem('user_name', res.data.friendlyName)
          const countryId = res.data.countryId !== null ? res.data.countryId : 233

          this.$store.commit('user/setCountry', countryId)
          this.$store.commit('user/setUserDetails', res.data)
          this.$store.commit('user/setAvatar', res.data.userImageUrl)
          this.$store.commit('user/setFirstName', res.data.firstName)
          this.$store.commit('user/setLastName', res.data.lastName)
          this.$store.commit('user/setUserId', res.data.id)
          this.$store.commit('user/setState', res.data.stateId)
          this.$store.commit('user/setPhone', res.data.phoneNumber)
          this.$store.commit('user/setAddressLine1', res.data.addressLine1)
          this.$store.commit('user/setAddressLine2', res.data.addressLine2)
          this.$store.commit('user/setCity', res.data.city)
          this.$store.commit('user/setPostalCode', res.data.postalCode)
          localStorage.setItem('email', res.data.email)
          this.$store.commit('setDashboardTourStart', 0)
          this.$store.commit('setNewUserLoggedin', true)
          this.$store.commit('setLearnStatus', true)
          this.$store.commit('setQuizStatus', true)
          this.$store.commit('course/setLastPlayedLevel', 0)
          this.$store.commit('course/setLevels', [])
          this.$store.commit('course/setGroups', [])
          this.$store.commit('course/setMemberId', 0)
          // this.$store.commit('course/setExamStatus', -1)
          this.$store.commit('course/setBadgeScore', -1)
          this.$store.commit('course/setCourseLevelLoadedAfterLogin', false)
        })
      },
      login () {
        this.loading = true
        let parameters = {
          grant_type: 'password',
          client_id: process.env.CLIENT_ID,
          client_secret: process.env.CLIENT_SECRET,
          username: this.email,
          password: this.password
        }
        // console.log(this.jsonToQueryString(parameters))
        this.loginLoader = true
        this.$auth.login({
          headers: {
          },
          data: this.jsonToQueryString(parameters),
          rememberMe: this.rememberMe,
          success (res) {
            this.$store.commit('setAuthToken', this.$auth.token())
            document.cookie = 'auth_token=' + this.$auth.token() + ';domain=cogneti.com'
            this.me()
          }
        })
      }
    },
    mixins: [crypto, common]
  }
</script>

<style>
@font-face{
  font-family: text-security-disc;
  src: url("/static/font/text-security-disc.woff");
}
.disk  input{
  -webkit-text-security: disc;
  font-family: text-security-disc;
}
.no-disk input{
  -webkit-text-security: none;
}
</style>



// WEBPACK FOOTER //
// src/components/views/sign-up/ConfirmPwd.vue